/* global currentAccountType, currentImpersonator, currentProfile */
/* eslint-disable import/extensions */
import enums from '@/utils/enum'
import { user } from '@/composables/useUser'

// We might want to consider moving the logic in this file into a better solution like a global singleton rather
// than having it all in a mixin

export default {
  data() {
    return {
      showTeamDomainModal: false,
      get account() {
        return {
          ...currentAccount,
          type: currentAccountType,
          get isGuest() {
            return typeof currentAccount !== 'object' || currentAccount.globalId === ''
          },
          get isFreelancer() {
            return this.type === enums.accountTypes.freelancer
          },
          get isCompany() {
            return this.type === enums.accountTypes.company
          },
          get isOrganization() {
            return this.type === enums.accountTypes.organization
          },
          get isRecruiter() {
            return this.type === enums.accountTypes.recruiter
          },
          get isTrusted() {
            return currentAccount.is_trusted === 1
          },
          get isVerified() {
            return currentAccount.is_verified === 1
          },
          get isApproved() {
            return currentAccount.status === 'approved'
          },
          get profile() {
            return currentProfile || {}
          },
        }
      },
      get user() {
        return user
      },
      get impersonator() {
        if (typeof currentImpersonator !== 'undefined') {
          return currentImpersonator
        }

        return null
      },
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
}
